module.exports = __webpack_public_path__ + "fonts/Intro-Regular.otf?2f11cb83f721271ebebd8f32af8d2068";